export const whiteboardInput = {
    id: '-1',
    text: ''
}